import React from "react";
import { Button, TableCell, TableRow, Typography } from "@mui/material";

const CustomizerCartItem = ({ item, handleEditOrder, handleRemoveItem, isRemoveBtn }) => {
  return (
    <TableRow>
      <TableCell>
        <img src={item.image} style={{ maxHeight: "75px", maxWidth: "75px" }} />
      </TableCell>
      <TableCell>
        <div>
          <Typography variant="body1">{item.productTitle}</Typography>
        </div>
        {item.customizedItem && (
          <div>
            <Typography variant="body1">{item.variantTitle}</Typography>
          </div>
        )}
      </TableCell>
      <TableCell>
        <Typography variant="body1">Qty: {item.quantity}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">${item.price.toFixed(2)}</Typography>
      </TableCell>
      <TableCell>
        {item.customizedItem && (
          <>
            <Button
              href={item.previewUrl}
              variant="contained"
              target="_blank"
              sx={{ padding: "4px 20px" }}
            >
              Preview
            </Button>
            <Button
              sx={{ padding: "4px 20px", margin: "0 10px" }}
              variant="contained"
              onClick={handleEditOrder}
            >
              Edit
            </Button>
          </>
        )}
        {isRemoveBtn && (
          <Button sx={{ padding: "4px 20px" }} variant="contained" onClick={handleRemoveItem}>
            Remove
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
};

export default CustomizerCartItem;
